import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'signal-h', 'SignalH', [["path",{"d":"M10 16v-8"}],["path",{"d":"M14 8v8"}],["path",{"d":"M10 12h4"}]]);